export const tzCorrectedDate = (date: Date): Date => {
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() + offset);
};
